// src/data/studiosData.js
// Static filter options for the Live Demos / Studios section
// Studio data is now fetched from Contentful via useStudios hook

/**
 * Domain filter options for the Studios UI
 * Note: Domain IDs match the normalized keys from Contentful
 * (supply_chain -> supply-chain, document_intelligence -> document-intelligence, ai/ml -> ai-ml)
 */
export const domainFilters = [
  { id: 'all', label: 'All' },
  { id: 'supply-chain', label: 'Supply Chain' },
  { id: 'document-intelligence', label: 'Document Intelligence' },
  { id: 'ai-ml', label: 'AI & GenAI' },
  { id: 'manufacturing', label: 'Manufacturing' },
];

/**
 * Status filter options for the Studios UI
 * Note: Status IDs match the normalized keys from Contentful
 * (in_lab -> in-lab, coming_soon -> coming-soon)
 */
export const statusFilters = [
  { id: 'all', label: 'All' },
  { id: 'live', label: 'Live Now' },
  { id: 'in-lab', label: 'In Lab' },
  { id: 'coming-soon', label: 'Coming Soon' }
];

// Empty studios array for backwards compatibility during transition
// Components should use useStudios() hook from src/hooks/useStudios.js
export const studios = [];
